import * as mutationTypes from "./mutation-types";
import { tableHelper } from "@/helpers/table.helper";
import { getBlankRecord } from "./helpers";
import { getBlankNextPreviousInfo } from "@/store/helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      data: [],
      paging: tableHelper.getDefaultPaging("Name"),
      criteriaInfo: tableHelper.getBlankCriteriaInfo(),
      loading: false,
      loaded: false
    },
    view: {
      data: getBlankRecord(),
      next: getBlankNextPreviousInfo(),
      previous: getBlankNextPreviousInfo(),
      breadcrumbs: [{ text: "..." }],
      loading: false,
      loaded: false,
      roleId: null
    },
    edit: {
      data: getBlankRecord(),
      isNew: true,
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutationTypes.STATE_HIDE_ERROR,
        hideArgument: "edit"
      }
    },
    delete: {
      id: null,
      saving: false
    },
    exportToExcel: {
      processing: false
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      loaded: false
    },
    view: {
      loaded: false
    }
  };
}
